import { Skeleton } from '@/app/shared/ui/Skeleton';

export interface TvlInfoProps {
  tvl: string;
  isLoading: boolean;
}

export const TvlInfo = ({ tvl, isLoading }: TvlInfoProps) => {
  return (
    <div className='flex gap-2.5'>
      <p className='text-gray-400'>TVL</p>
      <Skeleton.Line loading={isLoading} className='w-fit'>
        <p className='text-gray-50'>{tvl}</p>
      </Skeleton.Line>
    </div>
  );
};
